import { Injectable } from '@angular/core';
import { BuildSearchFilter } from '@greco/ngx-filters';

@Injectable({ providedIn: 'any' })
export class CategorySearchFilter extends BuildSearchFilter('CategorySearchFilter', {
  properties: ['label'],
  propertyLabels: ['Label'],
}) {}
